<div class="mx-auto w-full text-gray-900 bg-gray-100 p-2" role="contentinfo" aria-label="Seitenfuss">
    <div class="flex w-full items-center justify-left gap-4 text-xs">
        <div>&copy; 2026 Gartenwasserzähler</div>
        <div class="grow text-right text-gray-300"><app-version-component></app-version-component></div>
        <nav aria-label="Footer Navigation" class="flex items-center -justify-left gap-4 text-xs">
            <span><a routerLink="/impressum" class="footer-link" aria-label="Impressum">Impressum</a></span>
            <span><a routerLink="/datenschutz" class="footer-link" aria-label="Datenschutz">Datenschutz</a></span>
            <span><a routerLink="/kontakt" class="footer-link" aria-label="Kontakt">Kontakt</a></span>
        </nav>
    </div>
</div>
